import { TimeAgo } from '../../shared/date/time-ago';
import { ShowMoreToggle } from './show-more-toggle';
import ButtonHandler from '../../shared/product/button-handler';
import { PhotoCardSliderHandler } from '../../photo-card-slider/handler';
import { PRODUCT_RATING_STARS } from '../../classnames/reviews';
import { HIDDEN, ONE_CLICK_CHECKOUT_BUTTON } from '../../classnames/design-system';
import StarsRenderer from '../stars-renderer';
import { SELECTORS } from './constants';

export class Review {
  constructor(data) {
    this.node = document.querySelector(`.${SELECTORS.REVIEW}.${HIDDEN}`).cloneNode(true);
    this.slider = document.querySelector(`.${SELECTORS.SLIDER}`);
    this.data = data;
    this.stars = new StarsRenderer();
    this.checkoutBtn = new ButtonHandler(ONE_CLICK_CHECKOUT_BUTTON);
  }

  getPhotosContainer = () => (
    this.node.querySelector(`.${SELECTORS.PHOTOS}`)
  );

  renderText = (node, className, text) => {
    node.querySelector(`.${className}`).innerHTML = text;
  };

  renderData = (node) => {
    const MIN_CHARACTERS = 2;
    const { author: { name, location }, comments, date_created: date } = this.data;

    this.renderText(node, SELECTORS.NAME, name);
    this.renderText(node, SELECTORS.COMMENT, comments);
    this.renderStars(node);
    this.renderDate(node, SELECTORS.DATE, date);

    if (location?.length > MIN_CHARACTERS) {
      this.renderText(node, SELECTORS.LOCATION, location);
    }

    if (this.data.replies.length > 0) {
      this.renderReply(node);
    }
  };

  renderReply = (node) => {
    node.querySelector(`.${SELECTORS.REPLY}`).classList.remove(HIDDEN);

    const [{ comments }] = this.data.replies;
    const textContainer = node.querySelector(`.${SELECTORS.REPLY_COMMENT}`);
    const showMore = node.querySelector(`.${SELECTORS.REPLY_SHOW_MORE}`);

    this.renderText(node, SELECTORS.REPLY_COMMENT, comments);

    new ShowMoreToggle(textContainer, showMore).initialize();
  };

  updateSliderContent = () => {
    const node = document.querySelector(`.${SELECTORS.SLIDER}`);

    this.renderData(node);
  };

  renderStars = (node) => {
    this.stars.render(node.querySelector(`.${PRODUCT_RATING_STARS}`), this.data.rating);
  };

  renderDate = (node, className, date) => {
    [...node.querySelectorAll(`.${className}`)].forEach((container) => {
      container.innerHTML = TimeAgo.format(date);
    });
  };

  renderPhotos = () => {
    if (this.data.photos.length) {
      this.getPhotosContainer().classList.remove(HIDDEN);

      const slider = new PhotoCardSliderHandler(this.data.photos, this);

      slider.initUI();
    }
  };

  renderBtns = () => {
    const container = document.querySelector(`.${SELECTORS.ACTIONS}`);

    if (container) {
      const variantId = container.getAttribute('data-variant-id');
      const variantData = window.variantDataSelector.getData(variantId);

      this.checkoutBtn.handle(variantData, container);
    }
  };

  render = () => {
    this.renderData(this.node);
    this.node.classList.remove(HIDDEN);

    if (this.slider) {
      this.renderPhotos();
      this.renderBtns();
    }
  };
}
